import {
  AnswersApi,
  ApplicantsApi,
  AttemptsApi,
  AuthApi,
  CategoriesApi,
  Configuration,
  ConfigurationParameters,
  FreeTextAnswersApi,
  MultipleChoiceAnswersApi,
  QuestionsApi,
  ScoresApi,
  SettingsApi
} from '../generated/api';
import { getApiBaseUrl, getApplicantCode, getJwtAccessToken } from './utils/apiUtils';

const getApiClientConfiguration = () => {
  const configurationParameters: ConfigurationParameters = {
    basePath: getApiBaseUrl()
  };

  const authorizationHeader = getJwtAccessToken();
  if (authorizationHeader) {
    configurationParameters.accessToken = authorizationHeader;
  }
  const applicantHeader = getApplicantCode();
  if (applicantHeader) {
    configurationParameters.apiKey = applicantHeader;
  }

  return new Configuration(configurationParameters);
};

export const getAuthenticationApiClient = async (): Promise<AuthApi> => {
  const config = getApiClientConfiguration();
  return new AuthApi(config);
};

export const getApplicantApiClient = async (): Promise<ApplicantsApi> => {
  const config = getApiClientConfiguration();
  return new ApplicantsApi(config);
};

export const getSettingsApiClient = async (): Promise<SettingsApi> => {
  const config = getApiClientConfiguration();
  return new SettingsApi(config);
};

export const getCategoriesApiClient = async (): Promise<CategoriesApi> => {
  const config = getApiClientConfiguration();
  return new CategoriesApi(config);
};

export const getQuestionsApiClient = async (): Promise<QuestionsApi> => {
  const config = getApiClientConfiguration();
  return new QuestionsApi(config);
};

export const getMultipleChoiceAnswersApiClient = async (): Promise<MultipleChoiceAnswersApi> => {
  const config = getApiClientConfiguration();
  return new MultipleChoiceAnswersApi(config);
};

export const getFreeTextAnswersApiClient = async (): Promise<FreeTextAnswersApi> => {
  const config = getApiClientConfiguration();
  return new FreeTextAnswersApi(config);
};

export const getAttemptsApiClient = async (): Promise<AttemptsApi> => {
  const config = getApiClientConfiguration();
  return new AttemptsApi(config);
};

export const getAnswersApiClient = async (): Promise<AnswersApi> => {
  const config = getApiClientConfiguration();
  return new AnswersApi(config);
};

export const getScoresApiClient = async (): Promise<ScoresApi> => {
  const config = getApiClientConfiguration();
  return new ScoresApi(config);
};
